import gql from 'graphql-tag'

import { Query } from '../../types-graphql'
import { enrolExternalCourseFragment } from './fragments'

export type TDataExternalCourseUsers = Pick<
  Query,
  'externalCourseUsers' | '__typename'
>
export const EXTERNAL_COURSE_USERS = gql`
  query (
    $areaId: ID
    $externalCourseId: ID!
    $q: ExternalCourseUserRansack
    $page: Int
    $perPage: Int
  ) {
    externalCourseUsers(
      areaId: $areaId
      externalCourseId: $externalCourseId
      q: $q
      page: $page
      perPage: $perPage
    ) {
      nodes {
        ...EnrolExternalCourseFragment
      }
      pagesCount
      nodesCount
      hasNextPage
      hasPreviousPage
    }
  }
  ${enrolExternalCourseFragment}
`
